import { getCart, getCartSummary, getCartUnapproved, orderCart, patchInCart, putInCart, removeFromCart, validateCart } from '@/api/cart'
import Vue from 'vue'

const cart = {
  namespaced: true,
  state: () => ({
    status: {
      items: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      summary: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      unapproved: {
        initialized: false,
        refreshing: false,
        error: false,
      },
    },
    items: [],
    summary: {
      items: 0,
      productPoints: 0,
      taxPoints: 0,
    },
    unapproved: {
      items: 0,
      productPoints: 0,
      taxPoints: 0,
    },
    usePointsToPayTaxes: false,
    orderEmailAddress: ''
  }),
  getters: {},
  actions: {
    setUsePointsToPayTaxes({ commit }, usePoints) {
      return new Promise((resolve, reject) => {
        commit('SET_USE_POINTS_TO_PAY_TAXES', usePoints)
        resolve()
      })
    },
    setOrderEmailAddress({ commit }, emailAddress) {
      return new Promise((resolve, reject) => {
        commit('SET_ORDER_EMAIL_ADDRESS', emailAddress)
        resolve()
      })
    },
    fetchCart({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'items')
        commit('SET_ERROR_FALSE', 'items')
        getCart(0, 20)
          .then((cartItems) => {
            commit('SET_INITIALIZED_TRUE', 'items')
            commit('SET_REFRESHING_FALSE', 'items')
            commit('SET_ITEMS', cartItems)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'items')
            commit('SET_ERROR_TRUE', 'items')
            reject(err)
          })
      })
    },
    fetchCartSummary({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'summary')
        commit('SET_ERROR_FALSE', 'summary')
        getCartSummary()
          .then((summary) => {
            commit('SET_INITIALIZED_TRUE', 'summary')
            commit('SET_REFRESHING_FALSE', 'summary')
            commit('SET_SUMMARY', summary)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'summary')
            commit('SET_ERROR_TRUE', 'summary')
            reject(err)
          })
      })
    },
    fetchCartUnapproved({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'unapproved')
        commit('SET_ERROR_FALSE', 'unapproved')
        getCartUnapproved()
          .then((unapproved) => {
            commit('SET_INITIALIZED_TRUE', 'unapproved')
            commit('SET_REFRESHING_FALSE', 'unapproved')
            commit('SET_UNAPPROVED', unapproved)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'unapproved')
            commit('SET_ERROR_TRUE', 'unapproved')
            reject(err)
          })
      })
    },
    async addCartItem({
      commit,
      dispatch
    }, data) {
      try {
        await putInCart(data.productVersionId, data.quantity, data.categoryID);
      }
      catch (e) {
        throw e;
      }
      finally {
        dispatch('fetchCart')
        dispatch('fetchCartSummary')
      }
    },
    patchCartItem({
      commit,
      dispatch
    }, data) {
      return new Promise((resolve, reject) => {
        patchInCart(data.cartItemId, data.productVersionId, data.quantity)
          .then(() => {
            resolve()
            dispatch('fetchCart')
            dispatch('fetchCartSummary')
          })
          .catch((err) => {
            reject(err)
            dispatch('fetchCart')
            dispatch('fetchCartSummary')
          })
      })
    },
    removeCartItem({
      commit,
      dispatch
    }, cartItemId) {
      return new Promise((resolve, reject) => {
        removeFromCart(cartItemId)
          .then(() => {
            resolve()
            dispatch('fetchCart')
            dispatch('fetchCartSummary')
          })
          .catch((err) => {
            reject(err)
            dispatch('fetchCart')
            dispatch('fetchCartSummary')
          })
      })
    },
    validateCart({
      commit,
      dispatch
    }, payTaxes) {
      return new Promise((resolve, reject) => {
        validateCart(payTaxes)
          .then((response) => {
            resolve(response)
            dispatch('fetchCart')
            dispatch('fetchCartSummary')
          })
          .catch((err) => {
            reject(err)
            dispatch('fetchCart')
            dispatch('fetchCartSummary')
          })
      })
    },
    orderCart({
      commit,
      dispatch
    }, data) {
      return new Promise((resolve, reject) => {
        orderCart(data.payTaxes, data.email)
          .then((response) => {
            resolve(response)
            dispatch('fetchCart')
            dispatch('fetchCartSummary')
          })
          .catch((err) => {
            reject(err)
            dispatch('fetchCart')
            dispatch('fetchCartSummary')
          })
      })
    },
  },
  mutations: {
    SET_INITIALIZED_TRUE: (state, dataName) => {
      state.status[dataName].initialized = true
    },
    SET_REFRESHING_TRUE: (state, dataName) => {
      state.status[dataName].refreshing = true
    },
    SET_REFRESHING_FALSE: (state, dataName) => {
      state.status[dataName].refreshing = false
    },
    SET_ERROR_TRUE: (state, dataName) => {
      state.status[dataName].error = true
    },
    SET_ERROR_FALSE: (state, dataName) => {
      state.status[dataName].error = false
    },
    SET_ITEMS: (state, payload) => {
      Vue.set(state, 'items', payload)
    },
    SET_SUMMARY: (state, payload) => {
      state.summary.items = payload.items
      state.summary.productPoints = payload.productPoints
      state.summary.taxPoints = payload.taxPoints
    },
    SET_UNAPPROVED: (state, payload) => {
      state.unapproved.items = payload.items
      state.unapproved.productPoints = payload.productPoints
      state.unapproved.taxPoints = payload.taxPoints
    },
    SET_USE_POINTS_TO_PAY_TAXES: (state, payload) => {
      state.usePointsToPayTaxes = payload
    },
    SET_ORDER_EMAIL_ADDRESS: (state, payload) => {
      state.orderEmailAddress = payload
    },
  },
}

export default cart
